import { Link, useParams } from 'react-router-dom';
import { catalogApi } from '../api/catalogApi';
import { useApi, useAsync } from '../hooks/useApi';
import { Loading, LoadError } from '../components/Loading';
import Crumbs from '../components/Crumbs';

export default function LanguagePage() {
  const { languageCode = '' } = useParams();
  const api = useApi();
  const { data, loading, error, reload } = useAsync(
    () => catalogApi.language(languageCode, api),
    [languageCode, api],
  );

  if (loading) return <main className="page"><Loading what="books" /></main>;
  if (error || !data) {
    return (
      <main className="page">
        <LoadError message={error ?? 'Language not found'} onRetry={reload} />
      </main>
    );
  }

  return (
    <main className="page">
      <Crumbs items={[{ label: 'Languages', to: '/' }, { label: data.name }]} />

      <header className="page-header">
        <h1>
          <span className="page-emblem" aria-hidden="true">{data.emblem}</span>
          {data.name}
          <span className="page-native">{data.nativeName}</span>
        </h1>
        <p className="muted">{data.blurb}</p>
      </header>

      <div className="section-head">
        <h2>Books</h2>
      </div>

      <div className="card-grid">
        {data.books.map((book) => (
          <Link key={book.id} to={`/books/${book.id}`} className="tile tile--book">
            <span className="tile-body">
              <span className="tile-title">{book.title}</span>
              <span className="tile-author">{book.author}</span>
              <span className="tile-blurb">{book.description}</span>
              <span className="tile-meta">
                {book.availableChapterCount} of {book.chapterCount} chapters ready ·{' '}
                {book.cardCount} cards
              </span>
            </span>
          </Link>
        ))}
      </div>
    </main>
  );
}
